import { css } from 'aphrodite';
import { useParams } from 'react-router';
import { HandwrittenCardProvider } from '../../../../extViewmodels';
import { useFullscreenModal } from '../../../../models/hooks/appStateHooks';
import { useHwcIndustryCategoryTemplate } from '../../../../queries';
import { LoadingSpinner } from '../../../../web/components/LoadingSpinner';
import { MultiContainerHeader } from '../../../../web/components/MultiContainerHeader';
import { baseStyleSheet } from '../../../../web/styles/styles';
import { styleSheet } from './styles';

export function ViewHandwrittenCardTemplate() {
	const { id } = useParams<{ id: string }>();
	const templateQuery = useHwcIndustryCategoryTemplate({ templateId: id });
	const fullscreenModal = useFullscreenModal();
	const template = templateQuery?.data?.template;

	const onClickToClose = () => fullscreenModal.dismissModal();

	return (
		<>
			<MultiContainerHeader fullscreenHeader='View Handwritten Card Template' />
			{templateQuery.isPending ? <LoadingSpinner type='large' /> : null}
			{!template && templateQuery.error ? <h2>Something went wrong loading template data</h2> : null}
			{template ? (
				<section className={css(styleSheet.root)}>
					<h2 className={css(styleSheet.headerLabel, styleSheet.headerDisplayName)}>Card Name</h2>
					<span className={css(styleSheet.content)}>{template.name}</span>
					<div className={css(styleSheet.bodyCenter)}>
						<div className={css(styleSheet.sectionCustomDesign)}>
							<div className={css(styleSheet.sectionCustomDesignHeader)}>
								<h2 className={css(styleSheet.headerLabel, styleSheet.sectionCustomDesignHeaderLabel)}>Card Image</h2>
							</div>
							<figure className={css(styleSheet.templateImageContainer)}>
								<img className={css(styleSheet.templateImage)} src={template.image?.publicUrl} alt={template.name} />
							</figure>
						</div>
						<div className={css(styleSheet.sectionMessage)}>
							<div className={css(styleSheet.sectionCustomDesignHeader)}>
								<h2 className={css(styleSheet.headerLabel, styleSheet.sectionCustomDesignHeaderLabel)}>Message</h2>
							</div>

							<p dangerouslySetInnerHTML={{ __html: template.content.document }} />
							<div className={css(styleSheet.sectionCustomDesignHeader)}>
								<h2 className={css(styleSheet.headerLabel, styleSheet.sectionCustomDesignHeaderLabel)}>Product ID</h2>
							</div>
							<span className={css(styleSheet.content)}>
								{template.providerProductIds[HandwrittenCardProvider.Cardly]}
							</span>
						</div>
					</div>
					{template?.summary ? (
						<>
							<h2 className={css(styleSheet.headerLabel, styleSheet.headerDisplayName)}>Card Summary</h2>
							<p className={css(styleSheet.content)}>{template.summary}</p>
						</>
					) : null}
					{template?.keywords && template.keywords.length > 0 ? (
						<p className={css(styleSheet.content, styleSheet.contentSmall)}>
							<strong>Keywords: </strong>
							{template.keywords.join(', ')}
						</p>
					) : null}
					<footer className={css(styleSheet.footer)}>
						<button className={css(baseStyleSheet.ctaButton)} onClick={onClickToClose}>
							Close
						</button>
					</footer>
				</section>
			) : null}
		</>
	);
}
